import React from 'react';
import {FullscreenExit as MinimizeScreenIcon} from '@material-ui/icons';
import FullscreenIcon from '@material-ui/icons/Fullscreen';

import {usePlatformTranslation} from '../../../../../../services/hooks';

function VideoPlayerFullScreenButton({fullScreenVideoConference, setFullScreenVideoConference}) {
    const {videoConferences} = usePlatformTranslation();

    return (
        <div
            className="conference-buttons-container"
            onClick={() => setFullScreenVideoConference(!fullScreenVideoConference)}
        >
            <button className="toggle-fullscreen">
                {fullScreenVideoConference && (
                    <div>
                        <MinimizeScreenIcon />
                        <span>{videoConferences.minimizeScreen}</span>
                    </div>
                )}
                {!fullScreenVideoConference && (
                    <div>
                        <FullscreenIcon />
                        <span>{videoConferences.fullScreen}</span>
                    </div>
                )}
            </button>
        </div>
    );
}

export default VideoPlayerFullScreenButton;
